import {StockCategoriesListSearchComponent} from './StockCategoriesListSearchComponent'
import {StockCategoriesListToolbar} from './StockCategoriesListToolbar'

export const StockCategoriesListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <StockCategoriesListSearchComponent />
      <div className='card-toolbar'>
        <StockCategoriesListToolbar />
      </div>
    </div>
  )
}
